import React from "react"
import Link from "gatsby-link"
import AboutComponent from "../components/About"
import Layout from "../components/layout"

const LeadershipPage = () => (
  <Layout>
    <div>
      <meta name="apple-itunes-app" content="app-id=1322754821" />
      <meta name="title" content="Leadership - The Views News" />
      <meta
        name="description"
        content="Views is a product of many minds coming together. Learn more about the executives, writers, and designers."
      />

      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://viewsnews.co/leadership" />
      <meta property="og:title" content="Views Leadership" />
      <meta
        property="og:description"
        content="Views is a product of many minds coming together. Learn more about the executives, writers, and designers."
      />
      <meta
        property="og:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://viewsnews.co/leadership" />
      <meta property="twitter:title" content="Views Leadership" />
      <meta
        property="twitter:description"
        content="Views is a product of many minds coming together. Learn more about the executives, writers, and designers."
      />
      <meta
        property="twitter:image"
        content="https://i.postimg.cc/6qs9mJ4r/Top-Shelf-Copy.jpg"
      />
      <AboutComponent
        image="https://images.unsplash.com/photo-1494500764479-0c8f2919a3d8?ixlib=rb-0.3.5&ixid=eyJhcHBfaWQiOjEyMDd9&s=2cc7588cad463936fcda68b10311832d&q=100"
        title="Leadership"
        text="The Executives, The Writers, The Deisgners. Together, we deliver the best experience for our valued users"
      />
      <div className="LeadershipProfiles">
        <img src="https://i.postimg.cc/xT3X7hxz/IMG-0023.jpg" />
        <div className="LeadershipDescription">
          <h1>Sai Kambampati</h1>
          <h2>CEO and Founder</h2>
          <p>
            Sai Kambampati was born in California in 2001. As a child, he was
            always interested in computers. When he moved to India, he learned
            the basics of programming in HTML and Python and at the age of 14,
            Sai moved back to California and began to learn mobile development.
            Views is his first app on the App Store. Initially a news
            aggregator, Sai began to see a pursue a whole vision for Views and
            how much bigger it can be! In his free time, he enjoys spending time
            with his family, travelling, and watching Netflix.
          </p>
        </div>
      </div>
    </div>
  </Layout>
)

export default LeadershipPage
